const FETCH_POSTING_LEADS = 'desempeno/rendimiento/FETCH_POSTING_LEADS';
const FETCH_POSTING_LEADS_COMPLETED = 'desempeno/rendimiento/FETCH_POSTING_LEADS_COMPLETED';
const FETCH_POSTING_LEADS_FAILED = 'desempeno/rendimiento/FETCH_POSTING_LEADS_FAILED';
const FETCH_POSTING_LEADS_CHARTS = 'desempeno/rendimiento/FETCH_POSTING_LEADS_CHARTS';
const FETCH_POSTING_LEADS_CHARTS_COMPLETED = 'desempeno/rendimiento/FETCH_POSTING_LEADS_CHARTS_COMPLETED';
const FETCH_POSTING_LEADS_CHARTS_FAILED = 'desempeno/rendimiento/FETCH_POSTING_LEADS_CHARTS_FAILED';

export {
  FETCH_POSTING_LEADS,
  FETCH_POSTING_LEADS_COMPLETED,
  FETCH_POSTING_LEADS_FAILED,
  FETCH_POSTING_LEADS_CHARTS,
  FETCH_POSTING_LEADS_CHARTS_COMPLETED,
  FETCH_POSTING_LEADS_CHARTS_FAILED
};
